/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  empty,
  isArray,
  prepareResponseData,
} from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";
import "../dashboard/Dashboard.css";
import "../staff/Staff.css";

// api
import studentApi from "../../api/Student";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { FaPrint } from "react-icons/fa";
import { useContext } from "react";
import { AuthContext } from "../Root/ProtectedRoute";
import FullPageLoader from "../../components/loader/FullPageLoader";
import colors from "../../config/colors";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import EmptyListResponse from "../../components/emptyDiv/EmptyListResponse";
import TableLoading from "../../components/skeleton/TableLoading";
import StudentsTable from "../../components/tables/primeTable/students/StudentsTable";

const printReport = () => {
  window.print();
};

const StudentReports = ({ ...props }) => {
  const printRef = useRef();
  const { user } = useContext(AuthContext);
  const [filterValue, setFilterValue] = useState("");
  const [students, setStudents] = useState([]);

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { classId } = useParams();
  const toastTR = useRef(null);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (!classId) {
      navigate("/404");
    }
    getStudents();
  }, []);

  // filter search
  const filterSearch = (value) => {
    setFilterValue(value);
  };

  const getStudents = async () => {
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.getStudentsInClass(
        schoolId,
        null,
        null,
        null,
        classId,
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return [];
      }

      const data = isArray(response_data.response)
        ? response_data.response
        : [];
      setStudents(data);
      return data;
    } catch (error) {
      return [];
    }
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Student List" />
          <div className="report-sheet-contents-display">
            {!isLoading ? (
              <>
                <ButtonIcon
                  buttonText="Print"
                  icon={<FaPrint />}
                  marginTop={3}
                  iconMarginRight={8}
                  backgroundColor="transparent"
                  color={colors.primary}
                  borderColor={colors.primary}
                  height={30}
                  width={150}
                  onClick={() => printReport()}
                />
                <div className="transcript-container-script broad-sheet mt-20">
                  <div
                  className="transcript-display-script"
                  ref={printRef}
                  >
                    <div className="report-header">
                      <div style={{ width: 100, height: 100 }}>
                        <img
                          src={
                            !empty(user) && !empty(user.avatar)
                              ? user.avatar
                              : ""
                          }
                          alt="non"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>
                      <div>
                        <div className="report-title">
                          {!empty(user) && !empty(user.name) ? user.name : "NA"}
                        </div>
                        <div className="report-subtitle">
                          {!empty(user) && !empty(user.address)
                            ? user.address
                            : "NA"}
                        </div>
                        <div className="report-subtitle fs-14">
                          {`TEL.: ${
                            !empty(user) && !empty(user.phoneNumber1)
                              ? user.phoneNumber1 + " ,"
                              : ""
                          }${
                            !empty(user) && !empty(user.phoneNumber2)
                              ? user.phoneNumber2 + " ,"
                              : ""
                          }${
                            !empty(user) && !empty(user.ownerPhone)
                              ? user.ownerPhone
                              : ""
                          }`}
                        </div>
                        <div className="report-subtitle fs-14 mb-10">
                          {`Email: ${
                            !empty(user) && !empty(user.email)
                              ? user.email
                              : "---"
                          }`}
                        </div>
                      </div>
                      <div style={{ width: 100, height: 100 }}>
                        <img
                          src={
                            !empty(user) && !empty(user.avatar)
                              ? user.avatar
                              : ""
                          }
                          alt="none"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="transcript-student-data mt-30 mb-30">
                        <div className="transcript-student-details">
                          <div className="mt-5">
                            <strong>Session: </strong> {user?.currentSessionTitle || ''}
                          </div>
                          <div className="mt-5">
                            <strong>Term: </strong> {user?.currentTermTitle || ''}
                          </div>
                        </div>
                      </div>
                      {/* end menu header */}
                      {!isLoading ? (
                        <div style={{ width: "100%", marginTop: 10 }}>
                          <div>
                            {isArray(students) &&
                            !empty(students) ? (
                              <StudentsTable
                                students={students}
                                usingStaticForm={true}
                                filterValue={filterValue?.toLowerCase() === "in-active" ? 2 : 1}
                                filterSearch={filterSearch}
                              />
                            ) : (
                              <EmptyListResponse message="Sorry, there are no student record(s) available." />
                            )}
                          </div>
                        </div>
                      ) : (
                        <TableLoading />
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <EmptyListResponse />
            )}
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
        {isLoading && <FullPageLoader visible={isLoading} />}
      </AppWrapper>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default StudentReports;
